import * as React from "react";
const SvgFiRrHamsa = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hamsa_svg__a)">
      <path
        fill="#062147"
        d="M23.588 11.34C22.582 10.202 20.765 9.325 19 9.073V5.114c0-1.525-1.081-2.848-2.514-3.075a3 3 0 0 0-1.598.194A3 3 0 0 0 12-.001a3 3 0 0 0-2.888 2.234 2.8 2.8 0 0 0-.806-.219 3.03 3.03 0 0 0-2.318.76A3 3 0 0 0 5 4.999v4.074c-1.765.252-3.582 1.128-4.588 2.267a1.64 1.64 0 0 0-.338 1.574 1.74 1.74 0 0 0 1.222 1.164C3.88 14.743 3.996 16.78 4 17c0 4.448 2.369 7 6.5 7h3c4.13 0 6.5-2.552 6.5-6.99.005-.229.12-2.267 2.704-2.932a1.74 1.74 0 0 0 1.222-1.164 1.64 1.64 0 0 0-.338-1.574zM18 17c0 3.364-1.472 5-4.5 5h-3C7.472 22 6 20.364 6 17c0-1.235-.787-3.717-3.691-4.706C3.158 11.619 4.63 11 5.999 11a1 1 0 0 0 1-1V5a1 1 0 0 1 .33-.742c.213-.191.494-.279.777-.252.493.049.894.546.894 1.109v4.886a1 1 0 1 0 2 0V3a1.001 1.001 0 0 1 2 0v7a1 1 0 1 0 2 0V5a1.004 1.004 0 0 1 1.172-.986c.465.074.828.557.828 1.1V10a1 1 0 0 0 1 1c1.369 0 2.843.619 3.69 1.294C18.788 13.283 18 15.765 18 17m-6-4c-2.012 0-3.62 1.263-4.263 2.218A1.4 1.4 0 0 0 7.5 16c0 .274.079.547.237.782C8.379 17.736 9.987 19 12 19s3.62-1.263 4.263-2.218a1.4 1.4 0 0 0 0-1.564C15.62 14.263 14.012 13 12 13m0 4.5a1.5 1.5 0 1 1 0-3.001 1.5 1.5 0 0 1 0 3.001"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hamsa_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHamsa;
